<template>
  <g>
    <path d="M1 1L7 7L13 1" stroke="#333333" :stroke-width="strokeWidth"></path>
  </g>
</template>

<script>
export default {
  props: {
    strokeWidth: {
      type: Number,
      default: 2
    }
  }
}
</script>
